<template>
  <div>
    <a @click="toggleFaq()" class="sc-faq-link">
      <span>Questions?</span> Read the FAQ
      <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="faq" />
    </a>
    <transition
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      mode="out-in"
    >
      <div
        v-show="showFaq"
        class="sc-faq-box"
        :class="showFaq ? 'sc-faq-box-overlay' : ''"
        :style="`display: block;z-index:${highestZIndex + 18}`"
      >
        <div key="faq_box">
          <div class="faq-header">{{ faq.title }}</div>
          <div class="faq-content" v-html="faq.description"></div>
        </div>
        <div
          :class="{ rotateCenter: showFaq }"
          key="faq_close"
          @click="toggleFaq()"
          class="faq-close faq-close-action"
        >
          <span></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    faq: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showFaq: false,
      showFaqOverlay: false,
    };
  },
  watch: {
    showFaq() {
      if (!this.showFaq) {
        this.showFaqOverlay = this.showFaq;
      } else {
        setTimeout(() => {
          this.showFaqOverlay = this.showFaq;
        }, 500);
      }
    },
  },
  methods: {
    toggleFaq() {
      this.showFaq = !this.showFaq;
      this.styleSet();
    },
    styleSet() {
      for (let font of document.getElementsByTagName("font")) {
        font.style.color = font.getAttribute("color");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// FaqComponent.vue?22f027d0